var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCommentAltSolid = function SvgCommentAltSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25C6.47656 3.25 2 6.88672 2 11.375C2 13.3125 2.83594 15.0859 4.22656 16.4805C3.73828 18.4492 2.10547 20.2031 2.08594 20.2227C2 20.3125 1.97656 20.4453 2.02734 20.5625C2.07812 20.6797 2.1875 20.75 2.3125 20.75C4.90234 20.75 6.84375 19.5078 7.80469 18.7422C9.08203 19.2227 10.5 19.5 12 19.5C17.5234 19.5 22 15.8633 22 11.375C22 6.88672 17.5234 3.25 12 3.25Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommentAltSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment_alt_solid.01910a3e.svg";
export { ForwardRef as ReactComponent };